import { api } from "./api";

/**
 * Read the last-known walker region from `td_last_coords` so bare events
 * like `discover_view` and `map_view` — which don't have a location context
 * at fire-time — still land on the admin heatmap. Discover writes this key
 * once it knows which region the walker is browsing.
 */
function lastKnownRegion() {
  try {
    const raw = localStorage.getItem("td_last_coords");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed?.region === "string" && parsed.region.length > 0
      ? parsed.region
      : null;
  } catch {
    return null;
  }
}

/**
 * Persist the walker's current region alongside their cached coords.
 * Non-destructive — only updates the region field. Call this whenever
 * we learn a real region string (top Discover result, viewed trail, etc.).
 */
export function rememberRegion(region) {
  if (!region || typeof region !== "string") return;
  try {
    const raw = localStorage.getItem("td_last_coords");
    const existing = raw ? JSON.parse(raw) : {};
    if (existing.region === region) return; // no-op if unchanged
    localStorage.setItem(
      "td_last_coords",
      JSON.stringify({ ...existing, region, region_ts: Date.now() })
    );
  } catch {
    /* ignore */
  }
}

/** Fire-and-forget telemetry. Never throws, never blocks UI. */
export function track(event_type, event_data = {}, region = null) {
  try {
    const effectiveRegion = region || lastKnownRegion();
    api.post("/telemetry", { event_type, event_data, region: effectiveRegion }).catch(() => {});
  } catch {
    // ignore
  }
}
